// SPDX-License-Identifier: AGPL-3.0-or-later

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {VOICE_ROOM_THEME_MANIFEST} from '@fluxer/constants/src/VoiceRoomThemeManifest';
import type {VoiceRoomTheme} from '@fluxer/constants/src/VoiceRoomThemes';

// the room file is only ever the hashed name from the generated manifest, under the static CDN.
export function roomFileUrl(theme: VoiceRoomTheme): string {
	return `${RuntimeConfig.staticCdnEndpoint}/rooms/${VOICE_ROOM_THEME_MANIFEST[theme].file}`;
}
